import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Skeleton } from '@/components/ui/skeleton';
import { useAuth } from '../auth/AuthContext';
import { logout } from '../services/apiService';

export default function UserMenu() {
  const { t } = useTranslation('menu');
  const { isLoaded, isSignedIn, user } = useAuth();

  const handleLogout = async () => {
    try {
      const { logout_url } = await logout();
      window.location.href = logout_url;
    } catch (e) {
      console.error('Logout failed', e);
    }
  };

  if (!isLoaded) {
    return <Skeleton className="w-[100px] h-5 rounded" />;
  }

  if (!isSignedIn || !user) {
    return null;
  }

  const displayName =
    user.name || user.username || user.email || 'User';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-1.5 bg-transparent border-none text-sidebar-foreground text-sm font-medium cursor-pointer px-2 py-1.5 rounded-md transition-colors hover:bg-sidebar-accent hover:text-sidebar-accent-foreground">
          <span className="max-w-[120px] overflow-hidden text-ellipsis whitespace-nowrap">{displayName}</span>
          <svg
            className="transition-transform"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="currentColor"
          >
            <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        sideOffset={8}
        className="min-w-[180px] bg-slate-800 border-slate-700 rounded-lg shadow-lg z-[1000]"
      >
        <DropdownMenuItem
          onClick={handleLogout}
          className="flex items-center gap-2.5 px-4 py-3 text-[0.9rem] text-red-400 cursor-pointer focus:bg-red-400/10 focus:text-red-400"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="shrink-0 opacity-70 stroke-red-400">
            <path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          {t('logout')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
